import { render, staticRenderFns } from "./ticket-prices-seat.vue?vue&type=template&id=7ca054dc&scoped=true&"
import script from "./ticket-prices-seat.vue?vue&type=script&lang=js&"
export * from "./ticket-prices-seat.vue?vue&type=script&lang=js&"
import style0 from "./ticket-prices-seat.vue?vue&type=style&index=0&id=7ca054dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca054dc",
  null
  
)

export default component.exports